const Product = () => import('../views/ProductManage/products/index.vue');
export default [
  {
    path: '/product',
    name: '产品管理',
    component: Product,
    meta: [{ name: '产品目录' }],
  },
];
